import { useLocation } from '../contexts/LocationContext'
import StoreLogoComponent from './StoreLogoComponent'

const CurrentLocationIndicator = () => {
  const { currentStore, setLocationModalOpen } = useLocation()

  const getDisplayName = (storeId: string | null) => {
    return storeId || 'En kaupassa'
  }

  return (
    <button
      onClick={() => setLocationModalOpen(true)}
      className="flex items-center space-x-2 px-3 py-2 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow"
    >
      {currentStore ? (
        <StoreLogoComponent storeId={currentStore} size="md" />
      ) : (
        <div className="w-8 h-8 bg-gray-400 rounded-full flex items-center justify-center">
          <span className="text-sm text-white">🏠</span>
        </div>
      )}
      <div className="text-left">
        <div className="text-xs text-gray-500">Sijainti</div>
        <div className="text-sm font-medium">{getDisplayName(currentStore)}</div>
      </div>
      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </button>
  )
}

export default CurrentLocationIndicator